import React, { useCallback, useState } from "react";
import { Box, Dialog, DialogTitle, List, ListItemButton, ListItemText } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { activateWorkspace } from "../appStore/actions/workspace/action";

// With "All" shown, an action that belongs to one workspace asks which one
// first, then makes it the active workspace. Render `workspacePicker`, and
// await askWorkspace(): it gives the chosen workspace with the fresh profile
// (and whatever else its option had), or null if cancelled or it failed.
const useWorkspacePicker = () => {
  const dispatch = useDispatch();
  const subscribedTo = useSelector((state) => state?.profile?.profileData?.data?.subscribedTo);
  const [request, setRequest] = useState(null);

  const askWorkspace = useCallback(
    async ({ title, workspaces } = {}) => {
      const options =
        workspaces || (subscribedTo || []).map((account) => ({ id: account?.id, name: account?.subscriberFirmName }));
      if (!options.length) return null;
      const chosen = await new Promise((resolve) => setRequest({ title, options, resolve }));
      setRequest(null);
      if (!chosen) return null;
      const profile = await dispatch(activateWorkspace(chosen.id));
      return profile ? { ...chosen, profile } : null;
    },
    [dispatch, subscribedTo],
  );

  const workspacePicker = (
    <Dialog open={!!request} onClose={() => request?.resolve(null)} fullWidth maxWidth="xs">
      <DialogTitle sx={{ fontSize: "1rem", fontWeight: 400 }}>{request?.title}</DialogTitle>
      <Box pb="0.5rem">
        <List dense disablePadding sx={{ maxHeight: "60vh", overflow: "auto" }}>
          {request?.options.map((option) => (
            <ListItemButton key={option.id} onClick={() => request.resolve(option)}>
              <ListItemText primary={option.name} />
            </ListItemButton>
          ))}
        </List>
      </Box>
    </Dialog>
  );

  return { askWorkspace, workspacePicker };
};

export default useWorkspacePicker;
